import { Boundaries } from "@planzone/core";
import { Identifiable, Task } from "@planzone/dto";

function handleAssignTagRequest(
  task: Identifiable<Task>,
  { assignableId, tag }: Boundaries["assignTag"]["request"],
): Identifiable<Task> {
  return task.uuid === assignableId
    ? {
        ...task,
        tags: task.tags ? [...task.tags, tag] : [tag],
      }
    : task;
}

function handleAssignTagSuccess(
  task: Identifiable<Task>,
  { assignableId, tag }: Boundaries["assignTag"]["success"],
): Identifiable<Task> {
  if (task.uuid !== assignableId) return task;

  const tagExists = task.tags?.some(({ name }) => name === tag.name);

  return tagExists
    ? task
    : {
        ...task,
        tags: task.tags ? [...task.tags, tag] : [tag],
      };
}

function handleAssignTagFailure(
  task: Identifiable<Task>,
  { assignableId, tag }: Boundaries["assignTag"]["failure"],
): Identifiable<Task> {
  return task.uuid === assignableId
    ? {
        ...task,
        tags: task.tags.filter(({ name }) => name !== tag.name),
      }
    : task;
}

export {
  handleAssignTagRequest,
  handleAssignTagSuccess,
  handleAssignTagFailure,
};
